<template>
  <Context ref="context" overflow-scroll max-height-if-outside-viewport>
    <ul class="context__menu">
      <li class="context__menu-item">
        <button type="button" class="context__menu-item-link" @click="rename()">
          <i class="context__menu-item-icon iconoir-edit-pencil"></i>
          {{ $t('viewFolderContext.rename') }}
        </button>
      </li>
      <li class="context__menu-item">
        <!-- Deleting a folder does not delete the views inside it -- they
             return to the top level -- so this needs no confirmation step. The
             copy says so, because "delete folder" on a container of six saved
             views otherwise reads as destructive. -->
        <button
          v-tooltip="$t('viewFolderContext.deleteDescription')"
          type="button"
          class="context__menu-item-link context__menu-item-link--delete"
          :class="{ 'context__menu-item-link--loading': deleteLoading }"
          @click="remove()"
        >
          <i class="context__menu-item-icon iconoir-bin"></i>
          {{ $t('viewFolderContext.delete') }}
        </button>
      </li>
    </ul>
  </Context>
</template>

<script>
import context from '@baserow/modules/core/mixins/context'
import { notifyIf } from '@baserow/modules/core/utils/error'

/**
 * The per-folder overflow menu in the views rail. One instance is mounted for
 * the whole rail and re-anchored to the folder whose trigger was clicked, so
 * `folder` can be null while nothing is open.
 */
export default {
  name: 'ViewFolderContext',
  mixins: [context],
  props: {
    folder: {
      type: Object,
      required: false,
      default: null,
    },
    table: {
      type: Object,
      required: true,
    },
  },
  emits: ['rename'],
  data() {
    return {
      deleteLoading: false,
    }
  },
  methods: {
    rename() {
      this.hide()
      this.$emit('rename', this.folder)
    },
    async remove() {
      if (this.folder === null || this.deleteLoading) {
        return
      }
      this.deleteLoading = true

      try {
        await this.$store.dispatch('view/deleteFolder', this.folder)
      } catch (error) {
        notifyIf(error, 'view')
      }

      this.deleteLoading = false
      this.hide()
    },
  },
}
</script>
